/*
 * Copyright (c) Worldline 2023.
 */

/**
 * End user web services
 * Endpoints of end user web services
 *
 * The version of the OpenAPI document: 2.2.3-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {Locale} from './locale';
import {ConfigDto} from './configDto';


/**
 * This Dto gives information about a session.
 */
export interface SessionDto {
    /**
     * External Identifier of the Session.
     */
    extSessionId?: string;
    /**
     * External Identifier of the Subscriber.
     */
    extSubscriberId?: string;
    local?: Locale;
    /**
     * External Configuration Identifier.
     */
    extConfigId?: string;
    /**
     * User identifier, it is a declarative field to designate the person that create the session
     */
    userId?: string;
    /**
     * Session date creation
     */
    creationDate?: string;
    /**
     * URL to reach if session KO
     */
    urlKo?: string;
    /**
     * URL to reach if session COMPLETED
     */
    urlOk?: string;
    /**
     * URL to reach if session CANCELED.
     */
    urlCancel?: string;
    /**
     * URL to reach if session ON_HOLD.
     */
    urlOnHold?: string;
    /**
     * External status of the session.
     */
    externalSessionStatus?: SessionDto.ExternalSessionStatusEnum;
    /**
     * Purge status, it cna be NOT_PURGED, PURGED or TEMP_DATA_PURGED
     */
    purgeStatusAsString?: string;
    /**
     * Count the number of times the session has been set on hold
     */
    onHoldCounter?: number;
    configDto?: ConfigDto;
}
export namespace SessionDto {
    export type ExternalSessionStatusEnum = 'INIT' | 'COMPLETED' | 'CANCELED' | 'ERROR';
    export const ExternalSessionStatusEnum = {
        Init: 'INIT' as ExternalSessionStatusEnum,
        Completed: 'COMPLETED' as ExternalSessionStatusEnum,
        Canceled: 'CANCELED' as ExternalSessionStatusEnum,
        Error: 'ERROR' as ExternalSessionStatusEnum
    };
}


